import { render, staticRenderFns } from "./ViewBillingDetailsModal.vue?vue&type=template&id=4c837437&"
import script from "./ViewBillingDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewBillingDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports